import { InvalidateQueryFilters, useQuery, useQueryClient } from '@tanstack/react-query'
import { deleteEvent, getEventById, getEvents } from 'api/event'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TableConfig } from 'types/TableHeader'

export const useEventById = (id: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['event', id],
        queryFn: () => getEventById(id),
        enabled: !!id,
    })
    return { data, isLoading, error }
}

export const useEventByIdForSeats = (id: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['event', id],
        queryFn: () => getEventById(id),
        enabled: !!id,
        refetchInterval: 2000,
        refetchIntervalInBackground: true,
    })
    return { data, isLoading, error }
}

export const useEventsAdmin = (partnerId?: string) => {
    const [searchTerm, setSearchTerm] = useState('')
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const linkToForm = '/admin/esemenyek/form'

    const handleSearch = (value: string) => {
        setSearchTerm(value)
        queryClient.invalidateQueries(['events'] as InvalidateQueryFilters)
    }

    const handleEdit = (data: any) => {
        if (partnerId) {
            navigate(`/admin/esemenyek/form/${data.event_id}?partnerId=${partnerId}`)
        } else {
            navigate(`/admin/esemenyek/form/${data.event_id}`)
        }
    }

    const handleDelete = async (event_id: string) => {
        try {
            await deleteEvent(event_id)
            queryClient.invalidateQueries(['events'] as InvalidateQueryFilters)
        } catch (error) {
            console.error('Error deleting event:', error)
        }
    }

    const tableConfig: TableConfig = {
        titleRow: {
            title: 'Események',
            buttonLabel: 'Esemény felvétele',
            formConfig: {
                dialogProps: {
                    header: 'Esemény felvétele',
                },
            },
        },
        headers: [],
        idName: 'event_id',
    }

    //ADMIN
    const { data, isLoading, error } = useQuery({
        queryKey: ['events', searchTerm],
        queryFn: () => getEvents(searchTerm, true, partnerId),
    })

    return {
        data,
        linkToForm,
        isLoading,
        error,
        tableConfig,
        handleEdit,
        handleDelete,
        handleSearch,
    }
}
